export function formatTime(iso) {
    return new Date(iso).toLocaleTimeString("sv-SE", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }
  
  export function formatDate(iso) {
    return new Date(iso).toLocaleDateString("sv-SE");
  }
  
  export function timeAgo(iso) {
    const diff = Date.now() - new Date(iso).getTime();
    const min = Math.floor(diff / 60000);
  
    if (min < 1) return "just now";
    if (min < 60) return `${min} min ago`;
  
    const h = Math.floor(min / 60);
    if (h < 24) return `${h} h ago`;
  
    return formatDate(iso);
  }

  export function formatInitials(name) {
    if (!name) return ""
  
    const cleaned = name.trim()
  
    if (!cleaned.includes(" ")) {
      return cleaned.slice(0, 2).toUpperCase()
    }
  
    return cleaned
      .split(/\s+/)
      .slice(0, 2)
      .map(word => word[0])
      .join("")
      .toUpperCase()
  }
  
/**
 * Hur länge till något gäller. Används för check-in:ens expiresAt och för
 * ETA på en resa.
 *
 * Returnerar null när tiden redan passerat — anroparen ska då visa något
 * annat än "0 min kvar", som ser ut som ett fel.
 */
export function timeLeft(iso) {
  if (!iso) return null;

  const minutes = Math.round((new Date(iso).getTime() - Date.now()) / 60000);
  if (minutes <= 0) return null;
  if (minutes < 60) return `${minutes} min`;

  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;

  return rest ? `${hours} h ${rest} min` : `${hours} h`;
}

/** Klockslag i 24-timmarsformat, samma som notiserna använder. */
export function clockTime(iso) {
  if (!iso) return "";

  return new Date(iso).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
}
